import { useMemo } from 'react';

import {
  DiscoveryApi,
  FetchApi,
  discoveryApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { fetchApiRef } from '@backstage/frontend-plugin-api';

export interface ExchangeTokenApi {
  exchangeToken(): Promise<string | undefined>;
}

export class ExchangeTokenApiImpl implements ExchangeTokenApi {
  constructor(
    private readonly fetchApi: FetchApi,
    private readonly discoveryApi: DiscoveryApi,
  ) {}

  static create({
    discoveryApi,
    fetchApi,
  }: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }): ExchangeTokenApi {
    return new ExchangeTokenApiImpl(fetchApi, discoveryApi);
  }

  async exchangeToken(): Promise<string | undefined> {
    try {
      const url = `${await this.discoveryApi.getBaseUrl(
        'confidence',
      )}/exchange`;
      const response = await this.fetchApi.fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const resp = await response.json();
      return resp.token;
    } catch {
      // ignore
    }
    return undefined;
  }
}

export const useExchangeTokenApi: () => ExchangeTokenApi = () => {
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  return useMemo(() => {
    return ExchangeTokenApiImpl.create({ discoveryApi, fetchApi });
  }, []);
};
